import { createFileRoute } from "@tanstack/react-router";
import ClinicalResearchPage from "@/pages/ClinicalResearchPage";
export const Route = createFileRoute("/clinical-research")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Clinical Research Library | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Peer-reviewed research behind SAINT, TMS, and SPRAVATO: study designs, findings, limitations, and links to original sources. Evidence-based, not marketing.",
        },
        {
          property: "og:title",
          content: "Clinical Research Library | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Peer-reviewed research behind SAINT, TMS, and SPRAVATO: study designs, findings, limitations, and links to original sources. Evidence-based, not marketing.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/clinical-research",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/clinical-research",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ClinicalResearchPage />;
}
